export const FIELD_UPDATE_OPTIONS = {
    shouldDirty: true,
    shouldTouch: true,
    shouldValidate: true
};
